import PrintPreviewContainer from './container';
import PrintPreview from './PrintPreview';

export default PrintPreviewContainer;
export { PrintPreview };
